// extracted by mini-css-extract-plugin
export default {"app":"styles_app__rszEi","app__wrapper":"styles_app__wrapper__VXA13"};